import { createI18n } from 'vue-i18n';

import en_CA from './en-CA.json';
import fr_CA from './fr-CA.json';

const locale = document.documentElement.getAttribute('lang');
if (!locale) {
  throw new Error('No \'lang\' attribute found on <html> node.');
}

export type LocaleSchema = typeof fr_CA;
export type AvailableLocales = 'fr-CA' | 'en-CA';

const i18n = createI18n<[LocaleSchema], AvailableLocales, false>({
  legacy: false,
  locale: locale ?? 'fr-CA',
  messages: {
    'en-CA': en_CA,
    'fr-CA': fr_CA
  }
});

// i18n pour la validation
// setLocale(locale);
// configure({
//   generateMessage: localize({
//     'en-CA': {
//       messages: {
//         ...en.messages
//       },
//     },
//     'fr-CA': {
//       messages: {
//         ...fr.messages
//       },
//     },
//   }),
// });
export default i18n;
